<template lang="pug">
  nav#navSocial
    a(v-for="item of nav", :href="item.url", :title="item.title", target="_blank")
      component(v-bind:is="item.icon")
</template>

<script>
import './style.sass'

export default {
  name: 'NavSocial',
  props: {
    nav: Array
  }
}
</script>